var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('accordion-list',{staticClass:"mb-3",attrs:{"faqList":_vm.list}}),_vm._v(" "),_c('a',{staticClass:"btn button",attrs:{"href":"/faq"}},[_vm._v("ВСЕ ВОПРОСЫ ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }